import { createFileRoute } from "@tanstack/react-router";
import { useAuth } from "@/modules/auth/infrastructure/react/auth-provider";
import { AppShell } from "@/app/layout/AppShell";
import { DashboardPage } from "@/modules/dashboard/presentation/pages/DashboardPage";
import { LandingPage } from "@/app/marketing/LandingPage";

export const Route = createFileRoute("/")({
  component: RootIndex,
});

function RootIndex() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return null;

  if (isAuthenticated) {
    return (
      <AppShell>
        <DashboardPage />
      </AppShell>
    );
  }

  return <LandingPage />;
}
